import dayjs from "dayjs";

import { useActivityStatus } from "api/services/useActivityStatus";
import { ActivityStatus } from "types/activity-status";

type ActivityStatusField = keyof ActivityStatus;
type UseIsActivityOldReturn = {
  loading: boolean;
  isOld: boolean;
};

export function useIsActivityOld(activityStatusField: ActivityStatusField): UseIsActivityOldReturn {
  const { activityStatus, isLoadingActivityStatus: loading } = useActivityStatus();

  if (activityStatus === undefined) {
    return {
      loading,
      isOld: false,
    };
  }

  const fieldValue = activityStatus[activityStatusField];
  const lastActivity = fieldValue ? new Date(fieldValue) : null;

  const twoMonthsAgo = dayjs().subtract(2, "months");
  const isLastActivityOlderThanTwoMonthsAgo = lastActivity === null || twoMonthsAgo.isAfter(lastActivity);

  return {
    loading,
    isOld: isLastActivityOlderThanTwoMonthsAgo,
  };
}
